import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  link: {
    cursor: 'pointer',
    userSelect: 'none',
    textDecoration: 'underline'
  }
}))

export default useStyles
